import React, {FC, useState} from "react"

import {CompanyNewsTile, CompanyNewsTileType} from "@irati/types"
import FormattedMessage from "@irati/utils/lang"
import Icon from "@irati/ui/src/Icon"
import IconTypes from "@irati/ui/src/Icon/IconTypes.enum"
import tracking from "@irati-tracking/homepage"
import theme from "@irati/ui/src/global/theme"
import {Body} from "@irati/ui/src/Typography"

import NewContentModal from "../NewContent/Modal"
import {AddContent, EmptyCard} from "./styled"

interface Props {
  companyNewsTile: CompanyNewsTile
}

const EmptyTile: FC<Props> = ({companyNewsTile}) => {
  if (companyNewsTile.config.type !== CompanyNewsTileType.Empty) {
    return null
  }

  const [showModal, setShowModal] = useState(false)
  // if the content is smaller than 4, it has a md size also
  const isMidSizedContent = companyNewsTile.config.columnWidth < 4

  return (
    <>
      <EmptyCard
        color={theme.colors.greys.light}
        onClick={() => {
          tracking.homePageAddNewTileModal()
          setShowModal(true)
        }}
        isMisMidSizedContent={isMidSizedContent}>
        <AddContent>
          <div>
            <Icon icon={IconTypes.plus} />
          </div>
          <Body>
            <FormattedMessage id="platform.homepage.companyNews.newContent.button" />
          </Body>
        </AddContent>
      </EmptyCard>

      {showModal && <NewContentModal companyNewsTile={companyNewsTile} onClose={() => setShowModal(false)} />}
    </>
  )
}

export default EmptyTile
